import type { CatalogSection, CatalogTool } from '../../api/catalogApi';
import missions from '../../data/missions';
import MissionPanel from '../MissionPanel/MissionPanel';
import VaultPanel from './VaultPanel';

interface ToolWorkspaceProps {
  section: CatalogSection;
  tool: CatalogTool;
  onBack: () => void;
}

/** Mission-backed tools get their real panel; the rest show the generic example layout. */
export default function ToolWorkspace({ section, tool, onBack }: ToolWorkspaceProps) {
  if (section.id === 'vault') return <VaultPanel />;

  const mission = tool.mission_id ? missions.find((m) => m.id === tool.mission_id) : undefined;
  if (mission) return <MissionPanel mission={mission} onBack={onBack} />;

  return (
    <div className="split">
      <section className="panel">
        <h2>Run this tool</h2>
        <div className="drop">
          <b>Drop your file here</b>
          <span>.xlsx, .xls, .csv or .pdf, up to 50 MB</span>
          <button className="btn" style={{ marginTop: 8 }}>
            Browse files
          </button>
        </div>
        <div className="field">
          <label htmlFor="period">Period</label>
          <select id="period">
            <option>September 2026</option>
            <option>August 2026</option>
            <option>July 2026</option>
          </select>
        </div>
        <div className="row">
          <button className="btn primary">Run</button>
          <button className="btn">Reset</button>
        </div>
        <p className="note">This tool is not wired to a backend automation yet.</p>
      </section>
      <aside className="panel">
        <h2>About</h2>
        <dl>
          <div>
            <dt>Section</dt>
            <dd>{section.name}</dd>
          </div>
          <div>
            <dt>Type</dt>
            <dd>{tool.tag}</dd>
          </div>
          <div>
            <dt>Status</dt>
            <dd className="status">
              <i className="dot" />
              Ready
            </dd>
          </div>
        </dl>
      </aside>
    </div>
  );
}
